// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2laA1","paramInput":"JobSimulator_paramInput__2LO5j","input":"JobSimulator_input__2POf7"};